import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum IndividualPlanTargetStatusEnum {
    IN_PROGRESS = 'inProgress',
    DONE = 'done',
    UNFULFILLED = 'unfulfilled',
    CANCELLED = 'cancelled',
}

export const individualPlanTargetStatusEnumCZ: Record<IndividualPlanTargetStatusEnum, string> = {
    // TODO tisky na BE neumí číst překladové soubory
    [IndividualPlanTargetStatusEnum.IN_PROGRESS]: 'Trvá',
    [IndividualPlanTargetStatusEnum.DONE]: 'Splněn',
    [IndividualPlanTargetStatusEnum.UNFULFILLED]: 'Nesplněn',
    [IndividualPlanTargetStatusEnum.CANCELLED]: 'Zrušen',
};

export const individualPlanTargetStatusEnumOptions = enumToOptions(IndividualPlanTargetStatusEnum, 'individualPlan.target.status.');

export const individualPlanTargetStatusPriority: Record<IndividualPlanTargetStatusEnum, number> = {
    [IndividualPlanTargetStatusEnum.CANCELLED]: 1,
    [IndividualPlanTargetStatusEnum.UNFULFILLED]: 2,
    [IndividualPlanTargetStatusEnum.DONE]: 3,
    [IndividualPlanTargetStatusEnum.IN_PROGRESS]: 4,
};

export const individualPlanTargetStatusColor = {
    [IndividualPlanTargetStatusEnum.CANCELLED]: 'secondary',
    [IndividualPlanTargetStatusEnum.UNFULFILLED]: 'danger',
    [IndividualPlanTargetStatusEnum.DONE]: 'success',
    [IndividualPlanTargetStatusEnum.IN_PROGRESS]: 'primary',
};
